// Очистка ключа от el* символов
export const formatKey = (key) => {
  return key
    ?.split(/-?el*[0-9]*-?/gm)
    .filter(Boolean)
    .join("-");
};
